import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";

@Directive({
    // exportAs lets a template grab the directive instance (#ref="truncateText") so
    // (click) can call toggleText() on the DIRECTIVE. Event bindings resolve against the
    // host COMPONENT, not its directives — without this, (click)="toggleText()" looked for a
    // component method that doesn't exist and threw "toggleText is not a function" on click.
    selector: '[truncateText]',
    exportAs: 'truncateText',
    standalone: false
})
export class TruncateTextDirective{
    @Input('truncateText') maxLength:number = 18;

    isTruncated:boolean = true;
    // Remember the untruncated text so toggleText() can restore it (the old code only
    // stripped the trailing '...', which never brought back the clipped characters).
    private fullText = '';

    constructor(private el:ElementRef , private renderer: Renderer2){

    }

    ngAfterViewInit(){
        this.fullText = this.el.nativeElement.textContent ?? '';
        this.truncate();
    }

    truncate() {
        if (this.fullText.length > this.maxLength) {
          const truncatedText = this.fullText.substring(0, this.maxLength) + '...';
          this.renderer.setProperty(this.el.nativeElement, 'textContent', truncatedText);
          this.isTruncated = true;
        } else {
          this.isTruncated = false;
        }
      }

      // Toggle between the truncated preview and the full text on click. No-op when the text
      // is short enough that it was never truncated.
      toggleText() {
        if (this.fullText.length <= this.maxLength) return;
        if (this.isTruncated) {
          this.renderer.setProperty(this.el.nativeElement, 'textContent', this.fullText);
          this.isTruncated = false;
        } else {
          this.renderer.setProperty(this.el.nativeElement, 'textContent', this.fullText.substring(0, this.maxLength) + '...');
          this.isTruncated = true;
        }
      }

}